import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { AKAMAI_HOST, DEV_HOST, QA_HOST } from '../const/env';
// Defaults. These should be provided by channel apps OR sandbox instead.
const DEFAULT_APIGEE_URL = QA_HOST;
const DEFAULT_ASSETS_URL = DEV_HOST;
const DEFAULT_SERVICE_FILE_URL = `${AKAMAI_HOST}/serviceFiles/json/nonprod-disputes-config.json`;
const defaultConfig = {
    apiErrorCallback: () => undefined,
    authDomain: '',
    hosts: {
        apigee: new URL(DEFAULT_APIGEE_URL),
        assets: new URL(DEFAULT_ASSETS_URL),
        serviceFile: new URL(DEFAULT_SERVICE_FILE_URL)
    },
    lang: 'en',
    psccApigeeClientId: '',
    rcApigeeClientId: '',
    targetOrigin: ''
};
const ConfigContext = createContext({
    config: defaultConfig,
    authenticationRedirect: () => undefined,
    accountId: '',
    setConfig: () => undefined,
    triggerAnalyticsEvent: () => undefined,
    navigationHandler: () => undefined
});
export const ConfigProvider = ({ children, config: providedConfig, authenticationRedirect, accountId, triggerAnalyticsEvent, navigationHandler }) => {
    const [config, setConfig] = useState(providedConfig);
    const value = useMemo(() => ({
        config,
        setConfig,
        accountId,
        authenticationRedirect,
        triggerAnalyticsEvent,
        navigationHandler
    }), [
        config,
        setConfig,
        accountId,
        authenticationRedirect,
        triggerAnalyticsEvent,
        navigationHandler
    ]);
    useEffect(() => {
        if (!providedConfig) {
            return;
        }
        setConfig(providedConfig);
    }, [providedConfig]);
    return (_jsx(ConfigContext.Provider, Object.assign({ value: value }, { children: children })));
};
const useConfig = () => useContext(ConfigContext);
export default useConfig;
//# sourceMappingURL=config.context.js.map